import { render, staticRenderFns } from "./userInfoMobile.vue?vue&type=template&id=80e99d92&scoped=true"
import script from "./userInfoMobile.vue?vue&type=script&lang=js"
export * from "./userInfoMobile.vue?vue&type=script&lang=js"
import style0 from "./userInfoMobile.vue?vue&type=style&index=0&id=80e99d92&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e99d92",
  null
  
)

export default component.exports